export default "__VITE_ASSET__NAaHZ7$D__"